import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { MDASH, SITE_IS_AUTO } from '../../utility/constants';
import { formatDate, formatTime } from '../../utility/formatters';
export default React.forwardRef((props, ref) => {
    const appointments = props.records;
    React.useImperativeHandle(ref, () => ({
        getContent: () => ({
            headers: ['date', 'time', 'customer', 'vehicle'],
            records: appointments.map((x) => {
                var _a;
                return [
                    formatDate(x.appointment),
                    formatTime(x.appointment),
                    `${x.client.lastname}, ${x.client.firstname}`,
                    ((_a = x.vehicle) === null || _a === void 0 ? void 0 : _a.description) || '',
                ];
            }),
        }),
    }), [appointments]);
    return _jsx(_Fragment, { children: _jsxs("table", { className: "table table-striped w-100", children: [_jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", { children: "Date" }), _jsx("th", { children: "Time" }), _jsx("th", { children: "Customer" }), SITE_IS_AUTO && _jsx("th", { children: "Vehicle" }), _jsx("th", { children: "Notes" })] }) }), _jsx("tbody", { children: appointments.map((x) => {
                        var _a;
                        return _jsxs("tr", { children: [_jsx("td", { children: formatDate(x.appointment) }), _jsx("td", { children: formatTime(x.appointment) }), _jsx("td", { children: _jsxs("a", { href: `#/clients/${x.client.id}`, children: [x.client.lastname, ", ", x.client.firstname] }) }), SITE_IS_AUTO && _jsx("td", { children: ((_a = x.vehicle) === null || _a === void 0 ? void 0 : _a.description) || MDASH }), _jsx("td", { children: x.notes })] }, x.id);
                    }) })] }) });
});
